import ColorSchema from "./Color";
import {
  BsFillPlusCircleFill,
  BsThreeDotsVertical,
  BsTrashFill,
  BsPlus,
  BsList,
  BsRecordCircle,
  BsTrash,
  BsInfoCircle,
  BsArrowRight,
  BsArrowLeft,
  BsBarChartSteps,
  BsEnvelopeOpen,
  BsCardChecklist,
  BsShieldLock,
  BsFillDashCircleFill,
  BsCheck,
  BsChatRightText,
} from "react-icons/bs";
import {
  BiUser,
  BiSearchAlt,
  BiCircle,
  BiMinus,
  BiSun,
  BiGridAlt,
} from "react-icons/bi";
import { MdOutlineClose, MdOutlineAssignmentReturned } from "react-icons/md";
import { TbEdit, TbDoorExit } from "react-icons/tb";
import { TiTick } from "react-icons/ti";
import { FiShare2, FiPhoneCall, FiSend } from "react-icons/fi";
import { GoPrimitiveDot } from "react-icons/go";
import { HiOutlineTrash, HiOutlineShoppingCart } from "react-icons/hi";
import { RiLuggageDepositFill, RiCheckDoubleLine } from "react-icons/ri";
import {
  FaRegMoon,
  FaRegBell,
  FaUserTie,
  FaEye,
  FaUsers,
  FaHandsHelping,
  FaShoppingBasket,
} from "react-icons/fa";
import { ImHeadphones, ImEnter, ImExit } from "react-icons/im";
import { CgUserList, CgClipboard, CgDollar } from "react-icons/cg";
import { TiHomeOutline, TiTickOutline } from "react-icons/ti";
import {
  IoIosArrowUp,
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosArrowBack,
} from "react-icons/io";
import {
  AiOutlineSetting,
  AiOutlinePlusSquare,
  AiOutlineStop,
  AiOutlineHeart,
} from "react-icons/ai";
import { TfiPencil, TfiNotepad } from "react-icons/tfi";
import { VscCalendar, VscNotebook } from "react-icons/vsc";
import { GrMoney } from "react-icons/gr";
import { TbReportMoney } from "react-icons/tb";

type IconType = {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  containerIconClassName?: string;
  iconClassName?: string;
  color?: string;
};
const PlusCircle: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsFillPlusCircleFill
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const DotsIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsThreeDotsVertical
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const EditIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TbEdit
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// delete
const DeleteIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsTrashFill
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

// Plus
const PlusIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsPlus
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const PlusSquareIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <AiOutlinePlusSquare
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const UserIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BiUser
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const CloseIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <MdOutlineClose
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const ExitDoorIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TbDoorExit
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// list
const ListIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsList
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const SearchIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BiSearchAlt
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const ShareIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FiShare2
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const CircleFillIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <GoPrimitiveDot
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const CircleIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsRecordCircle
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const CircleIcon2: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BiCircle
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const TrashIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <HiOutlineTrash
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const MinusIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BiMinus
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const SunIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BiSun
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const MoonIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaRegMoon
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const GridIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BiGridAlt
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const BellIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaRegBell
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const PhoneIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FiPhoneCall
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const PhoneIcon2: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <ImHeadphones
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const HomeIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TiHomeOutline
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

// ArrowTopIcon
const ArrowTopIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <IoIosArrowUp
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

// ArrowBottomIcon
const ArrowBottomIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <IoIosArrowDown
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// ArrowRightIcon
const ArrowRightIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <IoIosArrowForward
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// ArrowLeftIcon
const ArrowLeftIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <IoIosArrowBack
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// ArrowRightIcon1
const ArrowRightIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsArrowRight
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// ArrowLeftIcon1
const ArrowLeftIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsArrowLeft
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const TickIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TiTickOutline
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const SettingIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <AiOutlineSetting
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const ManagerIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaUserTie
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const StepIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsBarChartSteps
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// eye icon
const EyeIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaEye
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
// envelope
const EnvelopeIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsEnvelopeOpen
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const UsersIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaUsers
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const HandIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaHandsHelping
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const ShoppingIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <HiOutlineShoppingCart
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const BasketIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FaShoppingBasket
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const ForbiddenIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsFillDashCircleFill
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const ListIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsCardChecklist
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const InfoCircleIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsInfoCircle
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const UserListIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <CgUserList
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const StopIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <AiOutlineStop
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const TelegramIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <FiSend
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const LockIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsShieldLock
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const TickIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TiTick
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const EntryIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <ImEnter
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const ExitIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <ImExit
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const DepotIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <RiLuggageDepositFill
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const ClipBoardIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <CgClipboard
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const EditIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TfiPencil
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const DoubleTickIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <RiCheckDoubleLine
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
const SimpleTickIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsCheck
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const HeartIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <AiOutlineHeart
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const DollarIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <CgDollar
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const DollarIcon1: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <TbReportMoney
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const CalendarIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <VscCalendar
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const NoteBookIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <VscNotebook
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const CoinIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <GrMoney
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};

const ChatIcon: React.FC<IconType> = ({
  width = 24,
  height = 24,
  style,
  color = `${ColorSchema.dark_custom}`,
  containerIconClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={containerIconClassName} style={{ width, height, ...style }}>
      <BsChatRightText
        className={iconClassName}
        style={{ width: "100%", height: "100%" }}
        color={color}
      />
    </div>
  );
};
export {
  PlusCircle,
  DotsIcon,
  EditIcon,
  DeleteIcon,
  PlusIcon,
  UserIcon,
  CloseIcon,
  ListIcon,
  SearchIcon,
  ShareIcon,
  CircleFillIcon,
  CircleIcon,
  CircleIcon2,
  TrashIcon,
  MinusIcon,
  SunIcon,
  MoonIcon,
  GridIcon,
  BellIcon,
  PhoneIcon1,
  PhoneIcon2,
  HomeIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowTopIcon,
  ArrowBottomIcon,
  ArrowRightIcon1,
  ArrowLeftIcon1,
  TickIcon,
  TickIcon1,
  SettingIcon,
  ManagerIcon,
  PlusSquareIcon,
  StepIcon,
  EyeIcon,
  EnvelopeIcon,
  UsersIcon,
  HandIcon,
  ShoppingIcon,
  BasketIcon,
  ListIcon1,
  UserListIcon,
  StopIcon,
  TelegramIcon,
  LockIcon,
  EntryIcon,
  ExitIcon,
  DepotIcon,
  ForbiddenIcon,
  InfoCircleIcon,
  ClipBoardIcon,
  EditIcon1,
  DoubleTickIcon,
  SimpleTickIcon,
  HeartIcon,
  DollarIcon,
  DollarIcon1,
  CalendarIcon,
  NoteBookIcon,
  CoinIcon,
  ChatIcon,
  ExitDoorIcon,
};
